import { PoseGender, PoseGuide } from './model/Challenges.types';
import { DEFAULT_POSES } from './pose-guide.constants';

const defaultImageIndexByUrl = new Map(
  Object.values(DEFAULT_POSES).flatMap((defaults) =>
    defaults.map((pose, index) => [pose.imageUrl, index] as const),
  ),
);

export const withGenderDefaults = (
  poses: PoseGuide[],
  gender: PoseGender,
): PoseGuide[] =>
  poses.map((pose) => {
    const index = defaultImageIndexByUrl.get(pose.imageUrl);
    return index === undefined
      ? pose
      : { ...pose, imageUrl: DEFAULT_POSES[gender][index].imageUrl };
  });
